import { Box, Text } from '@chakra-ui/react';
import { CellProps, UsageCellOptionProps } from '../types/Cell';

export const UsageCell = (props: CellProps): React.ReactElement => {
  const { allowedUsage, usedUsage } = props as UsageCellOptionProps;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      margin="15px 0"
      rowGap="10px"
    >
      <Text color="text.primary" textStyle="body.s.regular">
        {usedUsage}/{allowedUsage}
      </Text>
    </Box>
  );
};
